module.exports = __webpack_public_path__ + "img/booksweb.92ffd45a.webp";